import type { OnChangeValue, Option } from '@ksyos/design-system';
import { Select } from '@ksyos/design-system';
import type { OrganizationTypeWithLinkedProfessions } from '@common/enums/organizationType';
import { getSelectedLanguage } from '@frontend/translate';
import { Profession, professionsByOrganizationType } from '../../../common/enums/profession';

export interface ISelectProfessionProps {
    className?: string;
    error?: string;
    onChange: (profession: Profession | null, label?: string) => void;
    organizationType: OrganizationTypeWithLinkedProfessions | null;
    placeholder?: string;
    profession: Profession | null;
    showOnlyGpProfessions?: boolean;
}

export function SelectProfession(props: Readonly<ISelectProfessionProps>) {
    const professions: Option[] = getProfessionOptions(props.organizationType);
    const currentValue = props.profession ? getProfessionOption(props.profession) : null;

    return (
        <Select
            className={props.className}
            error={props.error}
            onChange={handleChange}
            options={professions}
            placeholder={props.placeholder}
            value={currentValue}
        />
    );

    function handleChange(newValue: OnChangeValue<Option, false>) {
        props.onChange(newValue?.value as Profession, newValue?.label);
    }

    function getProfessionOption(profession: Profession | string): Option {
        return {
            label: getSelectedLanguage().professionEnum[profession as Profession],
            value: `${profession}`,
        };
    }

    function getProfessionOptions(organizationType: OrganizationTypeWithLinkedProfessions | null): Option[] {
        const professionOptions = organizationType
            ? Object.keys(professionsByOrganizationType[organizationType]).map(getProfessionOption)
            : Object.keys(Profession).map(getProfessionOption);

        return professionOptions.sort((a, b) => a.label.localeCompare(b.label));
    }
}
